import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { useIsMobile } from "@/hooks/use-mobile";

export const SEOFooter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return null;
  }

  return (
    <footer className="fixed bottom-0 left-0 right-0 w-full bg-transparent z-10">
      <div className="container mx-auto px-4 py-2 max-w-4xl">
        <Collapsible open={isOpen} onOpenChange={setIsOpen}>
          <CollapsibleTrigger className="flex items-center justify-center gap-1 w-full text-[9px] text-muted-foreground/10 hover:text-muted-foreground/30 transition-colors">
            <span>More About the Stream</span>
            {isOpen ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
          </CollapsibleTrigger>
          
          <CollapsibleContent className="mt-2 bg-background/95 backdrop-blur-sm rounded-lg p-3">
            <article className="text-[9px] text-muted-foreground/20 leading-relaxed space-y-2">
              <h2 className="text-[10px] font-semibold text-muted-foreground/30">
                📝 Sky Lofi ATC: The Ultimate Focus Stream
              </h2>
              
              <p>
                Welcome to <strong>Sky Lofi ATC</strong>, the home for deep work and relaxation. 
                Our unique, always-on stream combines{" "}
                <a href="#player" className="text-muted-foreground/30 hover:underline">
                  ambient Lofi Hip Hop beats
                </a>{" "}
                with live, unfiltered Air Traffic Control (ATC) radio communications from major 
                international airports around the globe.
              </p>

              <p>
                We created this unique listening experience for students, developers, and 
                professionals seeking a dynamic, non-distracting background noise for focus. 
                The rhythmic, calming nature of the Lofi beats pairs perfectly with the subtle, 
                real-time transmissions from real-time ATC controllers, creating a powerful 
                sensory environment optimized for concentration and creative flow.
              </p>

              <div>
                <p className="font-medium text-muted-foreground/30 mb-1">Features of our stream:</p>
                <ul className="list-disc list-inside space-y-0.5 pl-4">
                  <li>
                    <strong>Live ATC Feeds:</strong> Authentic, real-time communications from 
                    air traffic controllers.
                  </li>
                  <li>
                    <strong>Curated Lofi Music:</strong> A hand-selected library of chill beats 
                    optimized for study and relaxation.
                  </li>
                  <li>
                    <strong>Unique Ambient Sound:</strong> The internet's best combination of 
                    Lofi music and aviation radio for a unique focus environment.
                  </li>
                </ul>
              </div>

              <p>
                Whether you're studying for an exam, writing code, or just looking for the 
                perfect ambient background noise to de-stress, Sky Lofi ATC is your unique 
                portal to relaxation and deep concentration.
              </p>
            </article>
          </CollapsibleContent>
        </Collapsible>

        <div className="text-[8px] text-muted-foreground/10 text-center mt-2">
          © {new Date().getFullYear()} Sky Lofi ATC. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
